import React from 'react';
import AudioFileIcon from '@mui/icons-material/AudioFile';
import { useAudioDownload } from '../../hooks/kontakte/useAudioDownload';
import DownloadButton from './DownloadButton';

interface AudioDownloadButtonProps {
    kontaktaufnahmeId: string;
    kontaktVorname?: string | null | undefined;
    kontaktNachname?: string | null | undefined;
    kontaktAudioDatei?: string | null | undefined;
    title?: string;
    size?: 'small' | 'medium' | 'large';
    color?: 'inherit' | 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';
}

const AudioDownloadButton: React.FC<AudioDownloadButtonProps> = ({
    kontaktaufnahmeId,
    kontaktVorname,
    kontaktNachname,
    kontaktAudioDatei,
    title = 'Download audio',
    size = 'small',
    color = 'default'
}) => {
    const { downloadAudio } = useAudioDownload();

    // Only render if audio file exists
    if (!kontaktAudioDatei) {
        return null;
    }

    return (
        <DownloadButton
            onClick={() => downloadAudio(kontaktaufnahmeId,kontaktVorname,kontaktNachname)}
            icon={<AudioFileIcon />}
            title={title}
            size={size}
            color={color}
        />
    );
};

export default AudioDownloadButton;

